<template>
  <!-- 仪表档案 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permission.meter_fee_records_import_payment"
          type="success"
          plain
          size="small"
          icon="el-icon-upload2"
          @click="openDialog('import')"
        >
          导入
        </el-button>
        <el-button
          v-if="permission.meter_fee_records_import_log"
          size="small"
          @click="openDialog('importLog')"
        >
          导入失败记录
        </el-button>
      </template>
      <template slot="dateRangeSearch">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 100%"
        >
        </el-date-picker>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      :title="dialogTitle"
      :width="dialogType == 'import' ? '400px' : '60%'"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <ImportFailedLogs
        v-if="isDialogShow && dialogType == 'importLog'"
        listApi="/api/shunt/meter/balance-change/fail-record/page"
        downloadApi="/api/shunt/meter/balance-change/fail-record/export"
      ></ImportFailedLogs>
      <ImportFile
        v-else-if="dialogType == 'import'"
        title=""
        :withApiTips="true"
        exportApi="/api/shunt/meter/balance-change/export-template"
        importApi="/api/shunt/meter/balance-change/import"
        @uploadCallBack="importCallBack"
      ></ImportFile>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { getDict } from '@/api/meter-management/index';
import { getAreaList } from '@/api/meter-management/meter-permission';
import { getPageList, remove } from '@/api/meter-management/meter-balance-records';

export default {
  components: {
    ImportFile: () => import('@/views/nursingHome/initData/importFile'),
    ImportFailedLogs: () => import('./components/import-failed-logs'),
  },
  data() {
    return {
      isPageCache: false, // 当前页面是否从后台直接显示的 true-从后台直接显示的，也就是页面是缓存状态 false-重新加载的
      areaCodes: [], // 区域列表
      searchForm: {}, // 搜索条件
      dateRange: [], // 搜索条件-起止日期
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      rowData: [], // 选中行对应的数据
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        dialogClickModal: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: true,
        searchMenuSpan: 24,
        menuWidth: 80,
        column: [
          {
            label: '仪表表号',
            prop: 'code',
            minWidth: 150,
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            display: false,
          },
          {
            label: '仪表名称',
            prop: 'name',
            minWidth: 150,
            search: true,
            maxlength: 30,
            showWordLimit: true,
            span: 8,
          },
          {
            label: '上级仪表',
            prop: 'parentName',
            minWidth: 150,
            display: false,
          },
          {
            label: '仪表类型',
            prop: 'meterType',
            type: 'select',
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
            span: 8,
          },
          {
            label: '仪表类别',
            prop: 'meterCategory',
            type: 'select',
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
            span: 8,
          },
          {
            label: '管理区域',
            prop: 'areaCode',
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            type: 'tree',
            search: true,
            searchClearable: false,
            searchOrder: 2,
            span: 8,
          },
          {
            label: '类型',
            prop: 'balanceChangeType',
            type: 'select',
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
            display: false,
          },
          {
            label: '发生日期',
            prop: 'dateRange',
            width: 90,
            hide: true,
            showColumn: false,
            search: true,
            searchslot: true,
            searchSpan: 12,
            display: false,
          },
          {
            label: '发生金额',
            prop: 'changeBalance',
            span: 8,
          },
          {
            label: '发生前余额',
            prop: 'beforeBalance',
            span: 8,
          },
          {
            label: '发生后余额',
            prop: 'afterBalance',
            span: 8,
          },
          {
            label: '发生时间',
            prop: 'operateTime',
            width: 130,
            span: 8,
          },
          {
            label: '操作人',
            prop: 'operatorName',
            display: false,
          },
          {
            label: '备注',
            prop: 'description',
            overHidden: true,
            span: 24,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
  },
  created() {
    getDict({ code: 'shunt_meter_type' }).then(({ data }) => {
      this.findObject(this.tableOption.column, 'meterType').dicData = data;
    });
    getDict({ code: 'shunt_meter_category' }).then(({ data }) => {
      this.findObject(this.tableOption.column, 'meterCategory').dicData = data;
    });
    getDict({ code: 'meter_balance_change_type' }).then(({ data }) => {
      this.findObject(this.tableOption.column, 'balanceChangeType').dicData = data;
    });
    this.initData();
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 从缓存状态恢复窗口显示时重新请求下数据
    if (this.isPageCache) {
      this.initData();
    }
    this.isPageCache = true;
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    initData() {
      getAreaList().then(({ data }) => {
        this.areaCodes = data || [];
        if (this.areaCodes.length > 0) {
          this.findObject(this.tableOption.column, 'areaCode').dicData = this.areaCodes;
          this.searchForm.areaCode = this.areaCodes[0].dictKey;
          this.loadData();
        }
      });
    },
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 450; // 表格区域初始化高度
      const searchH = 170; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.areaCode) return;
      page = page || this.tablePage;
      this.loading = true;
      getPageList(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      )
        .then(({ data }) => {
          this.tablePage.total = data.total;
          this.tableData = data.records;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /* 重置搜索 */
    searchReset() {
      this.dateRange = [];
      this.searchForm = {
        areaCode: this.areaCodes[0].dictKey,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.dealDateRange();
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.searchOperateDateStart = this.dayjs(this.dateRange[0]).format('YYYY-MM-DD');
        this.searchForm.searchOperateDateEnd = this.dayjs(this.dateRange[1]).format('YYYY-MM-DD');
      } else {
        this.searchForm.searchOperateDateStart = '';
        this.searchForm.searchOperateDateEnd = '';
        this.dateRange = [];
      }
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 删除数据 */
    doDel(ids) {
      this.$confirm('确定将选择数据删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({
            ids,
          });
        })
        .then(() => {
          this.updateTableDataSuccess();
          this.$message.success('操作成功!');
        });
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        import: '导入充值记录',
        importLog: '导入失败记录',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      if (type == 'view') {
        this.needCloseConfirm = false;
      } else {
        this.needCloseConfirm = true;
      }
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 导入成功的回调 */
    importCallBack(ret) {
      if (ret) {
        this.dialogType = '';
        this.isDialogShow = false;
        this.tablePage.currentPage = 1;
        this.tablePage.total = 0;
        this.tableData = [];
        this.loadData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
